export default class FormElements {
    constructor(elm, args) {
        const input = elm.querySelectorAll("input, select, textarea");

        function updateInputField(inputField) {
            if (inputField.value.length == 0) {
                inputField.classList.add("input-field--empty");
                inputField.classList.remove("input-field--full");
            }
            else {
                inputField.classList.add("input-field--full");
                inputField.classList.remove("input-field--empty");
            }
        }

        input.forEach(x => {
            updateInputField(x);
            x.addEventListener("input", y => {
                x.setCustomValidity('');
                updateInputField(x);
            });
            x.addEventListener('blur', y => {
                x.classList.add('validation-activated');
            });
            //x.addEventListener('invalid', y => {
            //    if (x.value == '') {
            //        x.setCustomValidity(x.dataset.requiredText);
            //        //
            //    } else if (x.validationMessage != x.dataset.matchText) {
            //        x.setCustomValidity(x.dataset.validationText);

            //    }
            //})
        })
    }
}
